import styled from 'react-emotion'
import themeVars from 'ui_theme/site/globals/site.variables'

export default styled('div')`
  font-weight: ${({ inheritWeight }) =>
    inheritWeight ? '' : themeVars.pageFontWeightSemiBold};
  font-size: ${({ size }) =>
    size === 'small' ? themeVars.fontSize : themeVars['14px']};
  letter-spacing: normal;
  color: ${({ color }) => (color ? themeVars[color] : 'inherit')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
